export const environment = {
  production_mg: true,
  cloud_base_url: "https://aio.norsup.eu",
  key: "ya5KX68A6W8zjW9NeNzRAAqvaordUN08",
  iv: "UAr1E5UU0G0Zpykq",
  siteKey: "6LcdBHwpAAAAALWQOBHKOlo7fhZXWR3zXiiFEeKm",
  fernet_key: "P7BbvNfMb9aPv8mUMhBoJvgXbV0OxhtMtBQ_CFOPTtA=",
  app_redirection: "aio1675761864769://user/details/",
  emqx_url: "s6cf3268.ala.dedicated.azure.emqxcloud.com",
  emqx_port: 8084,
  emqx_username: "emqxaioprd",
  emqx_pwd: "ROGbG5FGo6/zom9DAAaNIx0WlY",
};
